import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { SERVICES } from "@/lib/site";
import { ArrowUpRight, MapPin } from "lucide-react";

export default function Projects() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/buildings")
      .then((r) => setItems(r.data || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);
  return (
    <div data-testid="projects-page">
      <section className="px-6 md:px-12 pt-28 pb-12">
        <p className="font-mono text-[11px] uppercase tracking-[0.32em] text-[#d4af37]">— Projelerimiz</p>
        <h1 className="mt-3 font-display font-extrabold tracking-tighter text-5xl md:text-7xl lg:text-[8rem] leading-[0.85] max-w-5xl">
          İmzamızı taşıyan <span className="text-[#d4af37]">binalar.</span>
        </h1>
        <p className="mt-6 text-white/55 max-w-2xl">Eskişehir genelinde aktif olarak yürüttüğümüz ve tamamladığımız bina projelerimiz.</p>
      </section>

      <section className="px-6 md:px-12 pb-24">
        {loading ? (
          <div className="font-mono text-xs text-white/40">Yükleniyor...</div>
        ) : items.length === 0 ? (
          <div className="border border-dashed border-white/10 p-14 text-center text-white/45 font-mono text-xs uppercase tracking-[0.3em]" data-testid="projects-empty-state">
            Henüz proje eklenmedi. Yakında bu alanı imzalı projelerle dolduracağız.
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {items.map((b, i) => (
              <article
                key={b.id}
                data-testid={`project-card-${b.id}`}
                className="group relative aspect-[4/5] overflow-hidden bg-[#0a0a0a] ring-1 ring-white/5 hover:ring-[#d4af37]/60 transition"
              >
                <div
                  className="absolute inset-0 bg-cover bg-center scale-105 group-hover:scale-110 transition duration-700"
                  style={{ backgroundImage: `url(${b.image_url || SERVICES[i % 4].image})` }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-[#0a0a0a]/30 to-transparent" />
                <div className="relative h-full p-6 flex flex-col justify-between">
                  <div className="flex items-center justify-between">
                    <span className="text-[10px] font-mono uppercase tracking-[0.3em] bg-[#d4af37]/15 border border-[#d4af37]/30 text-[#d4af37] px-2 py-1">
                      {b.status || "aktif"}
                    </span>
                    <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/45">{String(i + 1).padStart(2, "0")}</span>
                  </div>
                  <div>
                    <div className="font-display text-3xl md:text-4xl tracking-tight text-white">{b.name}</div>
                    {b.address && (
                      <div className="mt-1 flex items-center gap-2 text-white/65 text-sm">
                        <MapPin className="h-3.5 w-3.5 text-[#d4af37]" /> {b.address}
                      </div>
                    )}
                    {b.description && <p className="mt-2 text-white/55 text-sm line-clamp-2">{b.description}</p>}
                    <Link to="/iletisim" className="mt-4 inline-flex items-center gap-2 text-[#d4af37] font-display text-xs uppercase tracking-[0.25em]">
                      Bilgi Al <ArrowUpRight className="h-3.5 w-3.5" />
                    </Link>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
